import React from "react";
import { FilterOptionsState } from "@mui/material/useAutocomplete";

import { countries, Country } from "../utils/countries";
import PrefixTextField from "../PrefixTextField";
import { PhoneFieldProps } from "./PhoneField.types";

const invalidKeys =
  "abcdefghijklmnopqrstyuvwxyzABCDEFGHIJKLMNOPQRSTUVXWYZ`~!@#$%^&*()-_=+{}[]:;\"',<.>/? ";

function PhoneField(props: PhoneFieldProps): JSX.Element {
  const { onKeyDown: onKeyDownProp } = props;

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (invalidKeys.includes(event.key)) {
        event.preventDefault();
      }
      onKeyDownProp?.(event);
    },
    [onKeyDownProp]
  );

  const filterOptions = (
    options: any[],
    state: FilterOptionsState<any>
  ): Country[] => {
    return options.filter((option: Country) => {
      const search = state.inputValue.toLowerCase().replaceAll("+", "");
      const name = option.name.toLowerCase();
      const containsName = name.includes(search);
      const prefix = option.phonePrefix.replaceAll("+", "").replaceAll(" ", "");
      const startWithPrefix = prefix.startsWith(search);
      return containsName || startWithPrefix;
    });
  };

  return (
    <PrefixTextField
      {...props}
      getPrefixOptionDescription={(option: Country) => option?.name}
      getPrefixOptionValue={(option: Country) => option?.phonePrefix}
      onKeyDown={handleKeyDown}
      prefixFilterOptions={filterOptions}
      prefixOptions={countries}
      prefixWidth={80}
    />
  );
}

export default PhoneField;
